import React from 'react';

import { cn } from '@change/ds-utils';

import type { TopStoryDesktop, TopStoryMobile } from '../../types';
import { TopImpactStorySummary } from '../TopImpactStorySummary';

import { TopImpactStoryAvatar } from './components/TopImpactStoryAvatar';
import { TopImpactStoryBadge } from './components/TopImpactStoryBadge';

type Props = {
	trackStoryClick: (url: string) => void;
	story: TopStoryDesktop & TopStoryMobile;
	isMobile?: boolean;
	isCenteredOnMobile?: boolean;
	onStoryFocus?: () => void;
};

export const TopImpactStoryBubble: React.FC<Props> = ({
	story,
	isMobile = false,
	isCenteredOnMobile = false,
	onStoryFocus,
	trackStoryClick,
}) => {
	return (
		<div className="flex flex-shrink-0 flex-col items-center justify-center">
			<div
				className={cn(!isMobile && ['absolute', story.top, story.transform])}
				data-testid="top-impact-story-bubble-wrapper"
			>
				<div className="group relative h-[180px] w-[180px]">
					<TopImpactStoryAvatar
						isMobile={isMobile}
						isCenteredOnMobile={isCenteredOnMobile}
						url={story.url}
						trackStoryClick={trackStoryClick}
						ariaLabel={story.ariaLabel}
						linkDataTestId={`${story.dataTestIdBase}-link`}
						image={story.image}
						altText={story.altText}
						imageDataTestId={`${story.dataTestIdBase}-image`}
						onStoryFocus={onStoryFocus}
						tabIndex={story.tabIndex}
						ariaHidden={story.ariaHidden}
					/>

					<TopImpactStoryBadge
						labelTitle={story.labelTitle}
						labelText={story.labelText}
						dataTestId={`${story.dataTestIdBase}-badge`}
					/>

					{!isMobile && (
						<TopImpactStorySummary summary={story.summary} dataTestId={`${story.dataTestIdBase}-summary`} />
					)}
				</div>
			</div>
		</div>
	);
};
